import React, { Component } from 'react'
import styled from 'styled-components'
import { withTranslation } from 'react-i18next'

import ThunderIcon from '../../../images/thunder.svg'
import InfoIcon from '../../../images/info.svg'

const NotificationContainer = styled.div`

    &.collapsed {
        display: inline;
        margin-right: 11px;
    }

    > div > img {
        display: inline-block;
        width: 20px;
        height: 20px;
    }
    
    > div > h3 {
        display: inline-block;
        width: 744px;
        margin: 8px 0 0 11px;
        font-family: Lato-Light;
        font-size: 18px;
        color: #4D4D4D;
        text-align: left;
        line-height: 22px;

        @media (max-width: 768px) {
            width: auto;
        }
    }

    > div > p {
        display: inline-block;
        width: 744px;
        font-family: Lato-Regular;
        font-size: 14px;
        color: #2B2B2B;
        line-height: 22px;
        margin: 4px 0 8px 31px;

        @media (max-width: 768px) {
            width: auto;
            display: block;
            margin: 0 0 6px 0;
        }
    }

    > div > p > a {
        font-family: Lato-Regular;
        font-size: 14px;
        color: #11959A;
        line-height: 22px;
        text-decoration: none;

        @media (max-width: 768px) {
            display: block;
            margin-left: 0;
        }
    }
`

class Notification extends Component {
  constructor(props) {
    super(props);
    this.state = { expanded: true };
  }

  toggle = () => {
    this.setState({ expanded: !this.state.expanded })
  }

  componentDidMount() {
    var anchors = document.getElementsByClassName('notification-late-bind');
    for (var i = 0; i < anchors.length; i++) {
      anchors[i].onclick = this.props.onLinkClick
    }
  }

  render() {
    const award = this.props.award;

    return (
      <NotificationContainer className={this.props.expanded ? "" : "collapsed"} >
        {this.props.expanded &&
          <div>
            <img alt="" src={award ? ThunderIcon : InfoIcon} />
            <h3>{this.props.title}</h3>
            <p dangerouslySetInnerHTML={{ __html: this.props.body }}></p>
          </div>
        }
        {!this.props.expanded &&
          <img alt="" src={award ? ThunderIcon : InfoIcon} />
        }
      </NotificationContainer>
    )
  }
}

export default withTranslation('translations')(Notification)
